import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CalculatePlanReviewFeeQueryVariables = Types.Exact<{
  input: Types.CalculatePlanReviewFeeInput;
}>;


export type CalculatePlanReviewFeeQuery = { __typename?: 'query_root', calculate_plan_review_fee?: { __typename?: 'CalculatePlanReviewFeeOutput', has_fee: boolean, amount?: number | null, currency?: string | null, missing_required: Array<string> } | null };


export const CalculatePlanReviewFeeDocument = gql`
    query calculatePlanReviewFee($input: CalculatePlanReviewFeeInput!) {
  calculate_plan_review_fee(input: $input) {
    has_fee
    amount
    currency
    missing_required
  }
}
    `;

/**
 * __useCalculatePlanReviewFeeQuery__
 *
 * To run a query within a React component, call `useCalculatePlanReviewFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculatePlanReviewFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculatePlanReviewFeeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculatePlanReviewFeeQuery(baseOptions: Apollo.QueryHookOptions<CalculatePlanReviewFeeQuery, CalculatePlanReviewFeeQueryVariables> & ({ variables: CalculatePlanReviewFeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculatePlanReviewFeeQuery, CalculatePlanReviewFeeQueryVariables>(CalculatePlanReviewFeeDocument, options);
      }
export function useCalculatePlanReviewFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculatePlanReviewFeeQuery, CalculatePlanReviewFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculatePlanReviewFeeQuery, CalculatePlanReviewFeeQueryVariables>(CalculatePlanReviewFeeDocument, options);
        }
export function useCalculatePlanReviewFeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalculatePlanReviewFeeQuery, CalculatePlanReviewFeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalculatePlanReviewFeeQuery, CalculatePlanReviewFeeQueryVariables>(CalculatePlanReviewFeeDocument, options);
        }
export type CalculatePlanReviewFeeQueryHookResult = ReturnType<typeof useCalculatePlanReviewFeeQuery>;
export type CalculatePlanReviewFeeLazyQueryHookResult = ReturnType<typeof useCalculatePlanReviewFeeLazyQuery>;
export type CalculatePlanReviewFeeSuspenseQueryHookResult = ReturnType<typeof useCalculatePlanReviewFeeSuspenseQuery>;
export type CalculatePlanReviewFeeQueryResult = Apollo.QueryResult<CalculatePlanReviewFeeQuery, CalculatePlanReviewFeeQueryVariables>;